import recurringTypes from './recurringTypes'

export const getRecurring = payload => ({
  type: recurringTypes.GET_RECURRING,
  payload
})

export const getRecurringSuccess = payload => ({
  type: recurringTypes.GET_RECURRING_SUCCESS,
  payload
})

export const getRecurringFailure = payload => ({
  type: recurringTypes.GET_RECURRING_FAILURE,
  payload
})

export const clearRecurring = () => ({
  type: recurringTypes.CLEAR_RECURRING
})

export const loadMore = payload => ({
  type: recurringTypes.LOAD_MORE,
  payload
})

export const setFilters = payload => ({
  type: recurringTypes.SET_FILTERS,
  payload
})

export const addRecurringTractor = (payload, callback) => ({
  type: recurringTypes.ADD_RECURRING_TRACTOR,
  payload,
  callback
})

export const addRecurringTractorSuccess = payload => ({
  type: recurringTypes.ADD_RECURRING_TRACTOR_SUCCESS,
  payload
})

export const addRecurringTractorFailure = payload => ({
  type: recurringTypes.ADD_RECURRING_TRACTOR_FAILURE,
  payload
})

export const updateRecurringTractor = (payload, callback) => ({
  type: recurringTypes.UPDATE_RECURRING_TRACTOR,
  payload,
  callback
})

export const updateRecurringTractorSuccess = payload => ({
  type: recurringTypes.UPDATE_RECURRING_TRACTOR_SUCCESS,
  payload
})

export const updateRecurringTractorFailure = payload => ({
  type: recurringTypes.UPDATE_RECURRING_TRACTOR_FAILURE,
  payload
})

export const deleteRecurringTractor = (payload, callback) => ({
  type: recurringTypes.DELETE_RECURRING_TRACTOR,
  payload,
  callback
})

export const deleteRecurringTractorSuccess = payload => ({
  type: recurringTypes.DELETE_RECURRING_TRACTOR_SUCCESS,
  payload
})

export const deleteRecurringTractorFailure = payload => ({
  type: recurringTypes.DELETE_RECURRING_TRACTOR_FAILURE,
  payload
})
